//Please add the language resource
const yard = {
  yardCode:'YardCode',
  yardName:'YardName',
  proviceName: 'ProviceName',
  cityName: 'CityName',
  addr:'Addr',
  yardTypeCode:'YardTypeCode',
  yardTypeName:'YardTypeName',
  contact:'Contact',
  tel:'Tel',
  email: 'Email',
  createTime:'CreateTime',
  creator:'Creator',
  updateTime:'UpdateTime',
  updater:'Updater',
  msg:{
  }
};
export default yard



// WEBPACK FOOTER //
// ./src/page/md/truck/lang/yard.en.js